import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            按类型探索影片
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            无论你喜欢哪种风格，蜜桃电影都能满足你的观影需求
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5" data-product-shop>
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-lg p-5 md:p-6 text-center border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center mx-auto mb-3 md:mb-4 rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 dark:group-hover:text-foreground-950 transition-all duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base mb-1">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 line-clamp-2">
                {cat.description}
              </p>
              <span className="inline-block mt-3 text-xs text-primary-500 font-medium">
                {cat.movieCount} 部影片
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}